import { createWorker } from 'tesseract.js';

function countLetters(value = '') {
  return (String(value).match(/\p{L}/gu) || []).length;
}

export function cleanOcrText(value = '') {
  const normalized = String(value)
    .normalize('NFKC')
    .replace(/[\u064B-\u065F\u0670]/g, '')
    .replace(/[|\\/_~`^*+=<>()[\]{}:;"“”'‘’.,!?@#$%&]/g, ' ')
    .replace(/(.)\1{3,}/gu, '$1$1')
    .replace(/\s+/g, ' ')
    .trim();

  const tokens = normalized
    .split(' ')
    .map((token) => token.replace(/[^\p{L}\p{N}-]/gu, ''))
    .filter(Boolean)
    .filter((token) => countLetters(token) >= 2)
    .filter((token) => {
      const letters = countLetters(token);
      return letters / Math.max(1, token.length) >= 0.55;
    });

  const cleaned = tokens.join(' ').replace(/\s+/g, ' ').trim();
  if (countLetters(cleaned) < 3) return '';
  return cleaned.slice(0, 180);
}

export function assessOcrQuality(rawText = '', cleanedText = '') {
  const raw = String(rawText).replace(/\s+/g, ' ').trim();
  if (!raw || !cleanedText) return 0;
  const rawLetters = countLetters(raw);
  const cleanLetters = countLetters(cleanedText);
  const retention = cleanLetters / Math.max(1, rawLetters);
  const tokenCount = cleanedText.split(/\s+/).filter(Boolean).length;
  const lengthScore = Math.min(1, cleanLetters / 10);
  const tokenScore = Math.min(1, tokenCount / 3);
  return Math.max(0, Math.min(1, retention * 0.45 + lengthScore * 0.35 + tokenScore * 0.2));
}

export async function extractRestaurantText(image, onProgress) {
  const worker = await createWorker('ara+eng', 1, {
    logger(message) {
      if (typeof message.progress === 'number') {
        onProgress?.(message.progress, message.status || 'Reading restaurant sign');
      }
    },
  });

  try {
    await worker.setParameters({
      preserve_interword_spaces: '1',
      tessedit_pageseg_mode: '11',
      user_defined_dpi: '220',
    });
    const result = await worker.recognize(image);
    const rawText = result.data.text.trim();
    const text = cleanOcrText(rawText);
    return {
      rawText,
      text,
      quality: assessOcrQuality(rawText, text),
      confidence: Math.max(0, Math.min(1, Number(result.data.confidence || 0) / 100)),
    };
  } finally {
    await worker.terminate();
  }
}
